<template>
  <div :class="isInPanel ? $style['container--panel'] : $style['container--toaster']">
    <div>
      <div v-if="lastNotifications">
        <NotificationContent
          v-for="notification in lastNotifications"
          :id="notification.orderId"
          :key="notification.id"
          :label="'1 ' + $t('notification.label.' + notification.type.toLowerCase())"
          :message="
            notification.type.toLowerCase() !== 'cancellation'
              ? notification.type.toLowerCase() === 'refused'
                ? `${notification.orderNumber}. ` + $t('notification.message.refused')
                : `${notification.orderNumber}. ` + $t('notification.message.more')
              : `${notification.orderNumber}. ` + $t('notification.message.hideNotification')
          "
          :type="notification.type.toLowerCase()"
          :need-close="needClose"
          :bg="notification.type.toLowerCase()"
          :icon="notification.type.toLowerCase()"
          :link="toLink(router, 1, notification.orderNumber, notification.type.toLowerCase())"
          :is-read="notification.isRead"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useRouter } from 'vue-router';
import type { PFSNotification } from '~/app/types/notificationType';
import { toLink } from '~/composables/notifications/useNotifications';

const router = useRouter();

type Props = {
  isInPanel: boolean;
  needClose?: boolean;
  hideNotifications?: boolean;
  lastNotifications: PFSNotification[];
};
withDefaults(defineProps<Props>(), {
  needClose: true,
  hideNotifications: false,
});
</script>

<style lang="postcss" module>
.container {
  &--toaster {
    position: fixed;
    right: 80px;
    top: 80px;
    min-width: 350px;
    z-index: 40;
  }
  &--panel {
    position: relative;
    z-index: 100;
    overflow-y: auto;
    height: 93%;
    border-radius: var(--border-radius-200);
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      margin-left: 2px;
    }

    &::-webkit-scrollbar-thumb {
      margin-top: 8px;
      margin-bottom: 8px;
      background: var(--color-primary-600);
      border-radius: 50px;
    }

    &::-webkit-scrollbar-track {
      margin-top: 8px;
      margin-bottom: 8px;
      background: var(--color-primary-300);
      border-radius: 50px;
    }
  }
}
</style>
